import { dismissedAnnouncementsAtom } from '@web-app/atoms/dismissedAnnouncementsAtom';
import { AnnouncementBanner } from '@web-app/components/Notifications/AnnouncementBanner';
import { useAnnouncements } from '@web-app/hooks/queries/announcements';
import { useAtom } from 'jotai';

export const AnnouncementContainer = (): JSX.Element | null => {
  const { data: announcements, isLoading } = useAnnouncements();
  const [dismissedIds, setDismissedIds] = useAtom(dismissedAnnouncementsAtom);

  if (isLoading || !announcements?.length) {
    return null;
  }

  const visibleAnnouncements = announcements.filter(
    (a) => !dismissedIds.includes(a.id),
  );

  if (!visibleAnnouncements.length) {
    return null;
  }

  const handleDismiss = (id: string) => {
    setDismissedIds((prev) => [...prev, id]);
  };

  return (
    <div className="flex flex-col gap-4">
      {visibleAnnouncements.map((announcement) => (
        <AnnouncementBanner
          key={announcement.id}
          announcement={announcement}
          onDismiss={handleDismiss}
        />
      ))}
    </div>
  );
};
